import { render, staticRenderFns } from "./AppInputAlert.vue?vue&type=template&id=460041a0&scoped=true"
import script from "./AppInputAlert.vue?vue&type=script&lang=js"
export * from "./AppInputAlert.vue?vue&type=script&lang=js"
import style0 from "./AppInputAlert.vue?vue&type=style&index=0&id=460041a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460041a0",
  null
  
)

export default component.exports